import React from 'react';
import { ListPlus, StickyNote } from 'lucide-react';

interface TaskActionsProps {
  taskId: string;
  isPreview: boolean;
  onAddSubtask: (taskId: string) => void;
  onUpdateNotes: () => void;
  hasNotes?: boolean;
}

export function TaskActions({
  taskId,
  isPreview,
  onAddSubtask,
  onUpdateNotes,
  hasNotes = false
}: TaskActionsProps) {
  if (isPreview) return null;

  return (
    <div className="flex gap-2 sm:gap-2">
      <button
        onClick={() => onAddSubtask(taskId)}
        className="flex items-center gap-1.5 sm:gap-1.5 px-3 py-2.5 sm:px-3 sm:py-2 text-xs sm:text-xs font-medium text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-700/50 hover:bg-gray-100 dark:hover:bg-gray-700 active:bg-gray-200 dark:active:bg-gray-600 rounded-xl sm:rounded-lg transition-colors border border-gray-200/50 dark:border-gray-600/50 touch-manipulation"
      >
        <ListPlus className="w-4 h-4 sm:w-3.5 sm:h-3.5" />
        <span>Sous-tache</span>
      </button>
      <button
        onClick={onUpdateNotes}
        className="flex items-center gap-1.5 sm:gap-1.5 px-3 py-2.5 sm:px-3 sm:py-2 text-xs sm:text-xs font-medium text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-700/50 hover:bg-gray-100 dark:hover:bg-gray-700 active:bg-gray-200 dark:active:bg-gray-600 rounded-xl sm:rounded-lg transition-colors border border-gray-200/50 dark:border-gray-600/50 touch-manipulation"
      >
        <StickyNote className="w-4 h-4 sm:w-3.5 sm:h-3.5" />
        <span>{hasNotes ? 'Modifier note' : 'Note'}</span>
      </button>
    </div>
  );
}
